module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('list-layout', {
    staticClass: "list-layout",
    attrs: {
      "pageSize": _vm.pageSize,
      "currentPage": _vm.currentPage,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleChange,
      "size-change": _vm.handleSizeChange
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("维修价格查询")]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "slot": "btn_tabs"
    },
    slot: "btn_tabs"
  }, [_c('el-tabs', {
    staticClass: "tab",
    attrs: {
      "value": _vm.activename
    },
    on: {
      "tab-click": _vm.handleTabClick
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "disabled": _vm.IsLoading,
      "label": "标准维修",
      "name": "base"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "disabled": _vm.IsLoading,
      "label": "故障维修",
      "name": "repair"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "slot": "search-bar",
      "inline": true
    },
    slot: "search-bar"
  }, [_c('el-form-item', {
    attrs: {
      "label": "品牌"
    }
  }, [_c('el-select', {
    staticClass: "form-input",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择或输入品牌"
    },
    on: {
      "change": _vm.changeBrand
    },
    model: {
      value: (_vm.Search.BrandName),
      callback: function($$v) {
        _vm.Search.BrandName = $$v
      },
      expression: "Search.BrandName"
    }
  }, _vm._l((_vm.BrandNames), function(item) {
    return _c('el-option', {
      key: item.Name,
      attrs: {
        "label": item.Name,
        "value": item.Name
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "机型"
    }
  }, [_c('el-select', {
    staticClass: "form-input",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择或输入机型"
    },
    model: {
      value: (_vm.Search.ProductModel),
      callback: function($$v) {
        _vm.Search.ProductModel = $$v
      },
      expression: "Search.ProductModel"
    }
  }, _vm._l((_vm.ProductModels), function(item) {
    return _c('el-option', {
      key: item.Name,
      attrs: {
        "label": item.Name,
        "value": item.Name
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "模块"
    }
  }, [_c('el-select', {
    staticClass: "form-input",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择或输入模块"
    },
    model: {
      value: (_vm.Search.ProductModule),
      callback: function($$v) {
        _vm.Search.ProductModule = $$v
      },
      expression: "Search.ProductModule"
    }
  }, _vm._l((_vm.ProductModules), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "物料名称"
    }
  }, [_c('el-input', {
    staticClass: "form-input",
    attrs: {
      "placeholder": "请输入物料名称/物料编码"
    },
    model: {
      value: (_vm.Search.Product),
      callback: function($$v) {
        _vm.Search.Product = $$v
      },
      expression: "Search.Product"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.IsLoading
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'NewRepair'
      }
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("新建维修单")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.IsLoading),
      expression: "IsLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "slot": "main-content",
      "element-loading-text": "加载中",
      "data": _vm.tableData
    },
    slot: "main-content"
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left",
            "inline": ""
          }
        }, [_c('table', {
          staticClass: "expend_table"
        }, [_c('tbody', [_c('tr', [_c('td', {
          attrs: {
            "width": "15%"
          }
        }, [_vm._v("无级别维修")]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "25%"
          }
        }, [_vm._v("不拆机维修，对主机进行清洁、调整和其他软件设置类操作")]), _vm._v(" "), _c('td', [_vm._v("清洁、调整、重装、恢复出厂设置")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("无级别维修")]), _vm._v(" "), _c('td', [_vm._v("解锁")]), _vm._v(" "), _c('td', [_vm._v("解锁")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("0级维修")]), _vm._v(" "), _c('td', [_vm._v("不拆机情况下对机械零部件维修或更换")]), _vm._v(" "), _c('td', [_vm._v("不拆机情况下的机械零部件维修或更换比如电池后盖，外置天线等")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1级维修")]), _vm._v(" "), _c('td', [_vm._v("拆机维修：机械零部件更换")]), _vm._v(" "), _c('td', [_vm._v("机械零部件：前壳组件、后壳组件、内置电池、TP组件、显示模组、听筒、扬声器、麦克风、振动器、摄像头、射频连接线、内置天线、按键、侧键、FPC、转轴等 PC：A/B/C/D壳件、SSD/硬盘、风扇/散热器件、USB小板/PCB组件、触控板、硬盘接口件/支架、内存（包换内存屏蔽盖）、WIFI模块（包换NGFF Holder）、LCD排线等；")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2级维修")]), _vm._v(" "), _c('td', [_vm._v("更换主板")]), _vm._v(" "), _c('td', [_vm._v("更换主板")])])])])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物料名称／编码",
      "width": "260"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-col', [_vm._v(_vm._s(props.row.Product.Name))]), _vm._v(" "), _c('el-col', [_vm._v("物料编码：" + _vm._s(props.row.Product.Code))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "品牌"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n        " + _vm._s(props.row.Product.Brand.Name) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "机型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n        " + _vm._s(props.row.Product.Model.Name) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "模块"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v("\n        " + _vm._s(props.row.Product.Module.Name) + "\n      ")]
      }
    }])
  }), _vm._v(" "), (_vm.activename == 'base') ? _c('el-table-column', {
    attrs: {
      "label": "标准维修费"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [(props.row.BasePrice !== 0) ? _c('span', [_vm._v("\n        ¥ " + _vm._s(props.row.BasePrice))]) : _c('span', [_vm._v("\n          暂无报价\n        ")])]
      }
    }])
  }) : _vm._e(), _vm._v(" "), (_vm.activename == 'repair') ? _c('el-table-column', {
    attrs: {
      "label": "故障维修费"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [(props.row.RepairPrice !== 0) ? _c('span', [_vm._v("\n        ¥ " + _vm._s(props.row.RepairPrice))]) : _c('span', [_vm._v("\n          暂无报价\n        ")])]
      }
    }])
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d2de4088"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Repair/RepairPricePage.vue
// module id = 769
// module chunks = 0